import { CardBrandLogoProps } from "../CardBrandLogo/CardBrandLogo.props";

/**
 * A masterlist of Card Issuers,
 * their known card prefixes,
 * and their number format.
 *
 * When available, the property `disambiguation` adds more context about the card brand.
 */
export const cardBrandData: Array<{
  brand: CardBrandLogoProps["brand"];
  format: string;
  disambiguation?: string;
  prefixes: Array<string>;
}> = [
  {
    brand: "visa",
    format: "4444 4444 4444 4444",
    prefixes: ["4"],
  },
  {
    brand: "mastercard",
    format: "4444 4444 4444 4444",
    prefixes: [
      "51",
      "52",
      "53",
      "54",
      "55",
      "2221",
      "2222",
      "2223",
      "2224",
      "2225",
      "2226",
      "2227",
      "2228",
      "2229",
      "223",
      "224",
      "225",
      "226",
      "227",
      "228",
      "229",
      "23",
      "24",
      "25",
      "26",
      "270",
      "271",
      "2720",
    ],
  },
  {
    brand: "amex",
    format: "4444 444444 44444",
    prefixes: ["34", "37"],
  },
  {
    brand: "discover",
    format: "4444 4444 4444 4444",
    prefixes: ["6011", "644", "645", "646", "647", "648", "649", "65"],
  },
  {
    brand: "jcb",
    format: "4444 4444 4444 4444",
    prefixes: ["3528", "3529", "353", "354", "355", "356", "357", "358"],
  },
  {
    brand: "diners",
    disambiguation: "Diners Club International",
    format: "4444 444444 4444",
    prefixes: ["36"],
  },
  {
    brand: "diners",
    disambiguation: "Diners Club Carte Blanche",
    format: "4444 444444 4444",
    prefixes: ["300", "301", "302", "303", "304", "305"],
  },
  {
    brand: "diners",
    disambiguation: "Diners Club enRoute",
    format: "4444 444444 4444",
    prefixes: ["2014", "2149"],
  },
  {
    brand: "diners",
    disambiguation: "Diners Club US & Canada",
    format: "4444 4444 4444 4444",
    prefixes: ["54"],
  },
  {
    brand: "unionpay",
    format: "4444 4444 4444 4444 444",
    prefixes: ["622"],
  },
  {
    brand: "unionpay",
    format: "4444 4444 4444 4444",
    prefixes: [
      "603601",
      "603265",
      "621977",
      "603708",
      "602969",
      "601428",
      "603367",
      "603694",
    ],
  },

  {
    brand: "unionpay",
    disambiguation: "China UnionPay co-branded with Discover",
    format: "4444 4444 4444 4444 444",
    prefixes: [
      "622126",
      "622127",
      "622128",
      "622129",
      "62213",
      "62214",
      "62215",
      "62216",
      "62217",
      "62218",
      "62219",
      "6222",
      "6223",
      "6224",
      "6225",
      "6226",
      "6227",
      "6228",
      "62290",
      "62291",
      "622920",
      "622921",
      "622922",
      "622923",
      "622924",
      "622925",
    ],
  },
];

export const cardBrandDataMapById = cardBrandData.reduce<
  Record<string, (typeof cardBrandData)[number]>
>((acc, card) => {
  acc[card.brand] = card;
  return acc;
}, {});
